import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
// import leaf from "../../Assets/Projects/leaf.png";
// import emotion from "../../Assets/Projects/emotion.png";
// import editor from "../../Assets/Projects/codeEditor.png";
// import chatify from "../../Assets/Projects/chatify.png";
// import suicide from "../../Assets/Projects/suicide.png";
// import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath=''
              isBlog={false}
              title="Node-Blog"
              description="A simple blogging platform built on Node.js and Express.js that uses EJS syntax for posting.

              To speed things up, Simple doesn't make use of user sessions. Since there are no sessions, there is no admin user. Simple makes all admin pages (new post, edit, etc) accessible to the public."
              ghLink="https://github.com/arunkjojo/node-blog"
              demoLink="https://github.com/arunkjojo/node-blog"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={``}
              isBlog={false}
              title="Pizza Order"
              description="Pizza order application like an eCommerce application. In here we use MongoDB, "
              ghLink="https://github.com/arunkjojo/pizza-order"
              demoLink="https://pizza-order-arunkjojo.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={``}
              isBlog={false}
              title="WhatsApp Clone"
              description="This application is a social medial application like whatsapp"
              ghLink="https://github.com/arunkjojo/whatsapp-clone"
              demoLink="https://ajoin-whatsapp.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={``}
              isBlog={false}
              title="Kerala2 Website"
              description="I added Google oAuth, a cloud server for image upload. Converted php site to progressive web application, then TWA. And deployed in Playstore."
              ghLink="https://github.com/arunkjojo/kerala2"
              demoLink="http://kerala2.com"
            />
          </Col>
                
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={``}
              isBlog={false}
              title="Help Line - Kerala"
              description="College academic project Using React JS and PHP APIs and CSS, MUI, and Protect Router"
              ghLink="https://github.com/arunkjojo/helplineKerala"
              demoLink=""              
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
